import Home from './Home'
import './home.css'

export default Home
